const env = {
  app: {
    name: import.meta.env.VITE_APP_NAME || 'F.O.W',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    env: import.meta.env.VITE_APP_ENV || 'development',
  },
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000/api',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 30000,
  },
  logging: {
    enabled: import.meta.env.VITE_ENABLE_LOGGING === 'true',
    level: import.meta.env.VITE_LOG_LEVEL || 'info',
  },
  redux: {
    devTools: import.meta.env.VITE_ENABLE_REDUX_DEVTOOLS === 'true',
  },
};

export const isDevelopment = env.app.env === 'development';
export const isProduction = env.app.env === 'production';
export const isStaging = env.app.env === 'staging';

export default env;
